import * as React from "react";
import Modal, { IModalProps } from "~/components/modal/modal";
import ProductImage from "~/components/product-image/product-image";
import { IProduct } from "~/types/product";
import Icon from "../icons/icon";
import classNames from "classnames";

export interface ProductImageModalProps
    extends Pick<IProduct, "imageSrcSet" | "imageFallbackSrc">,
        Pick<IModalProps, "isOpen" | "onRequestClose"> {}

const ProductImageModal: React.FC<ProductImageModalProps> = props => {
    const baseClass = "product-image-modal";
    const [isZoomedIn, setIsZoomedIn] = React.useState(false);
    const classes = classNames(baseClass, { [`${baseClass}--zoomed-in`]: isZoomedIn });

    const onClick = React.useCallback(
        (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
            event.stopPropagation();
            setIsZoomedIn(!isZoomedIn);
        },
        [isZoomedIn]
    );

    if (!props.imageSrcSet) {
        return null;
    }

    const onClose = () => {
        props.onRequestClose?.();
        setIsZoomedIn(false);
    };

    return (
        <Modal className={classes} noContainerMarkup isOpen={props.isOpen}>
            <div className={`${baseClass}__inner`} onClick={onClose}>
                <ProductImage
                    srcSet={props.imageSrcSet}
                    fallbackSrc={props.imageFallbackSrc}
                    sizes="100vw"
                    onClick={onClick}
                />
            </div>
            <button type="button" className="modal-close-button" onClick={onClose}>
                <Icon iconId="icon_28_close" />
            </button>
        </Modal>
    );
};

export default ProductImageModal;
